import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';
import { INotification } from '@Saral-Influencer-Marketing/saral-utils/src/models';
import { useNavigate } from 'react-router-dom';

import RightArrow from '@/components/Icons/icons/RightArrow';

import ButtonComponent from '../../ButtonComponent/ButtonComponent';

interface Props {
  notification: INotification;
  setShowNotificationDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  markSingleNotificationAsSeen: () => void;
}

const PersonalizationSuccessNotification = ({
  notification,
  setShowNotificationDropdown,
  markSingleNotificationAsSeen,
}: Props) => {
  const navigate = useNavigate();
  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="w-9 h-9 flex-shrink-0 text-xl flex center items-center">✨</div>
      <div className="text-div ">
        <h3 className="text-base font-medium text-default">SIA’s picked up your tone!</h3>
        <p className="text-sm font-normal text-subdued">
          SIA has absorbed your guidelines & can now generate personalised responses to your emails.
        </p>

        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            className="p-0"
            onClick={() => {
              markSingleNotificationAsSeen();
              navigate('/dashboard/inbox');
              setShowNotificationDropdown(false);
            }}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            <span className="text-sm">Try it Now</span>
          </ButtonComponent>
        </div>
        <p className="timestamp pt-2">{timeAgo(notification?.createdAt.toString())}</p>
      </div>
    </div>
  );
};

export default PersonalizationSuccessNotification;
